module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Notification2-9a33a91d12a252bd7bdd5a7b9c5f78ce.svg";